import getSymbolFromCurrency from 'currency-symbol-map';
import firebase from 'firebase';
import config from '../../config/appConfig';

var EventBus = require('eventbusjs');
var promiseCache = {};
var visitorByCityPromiseCache = {};
var inquiryByCityPromiseCache = {};
var companyCache = {};
var companyId = '';
var repeatCount;

let app = firebase.initializeApp({
  apiKey: 'AIzaSyDNNSLR8YDmIVMOQ8SN_qAObDB_674V_24',
  authDomain: 'quickselluserfeedback.firebaseapp.com',
  databaseURL: 'https://quickselluserfeedback.firebaseio.com',
  projectId: 'quickselluserfeedback',
  storageBucket: 'quickselluserfeedback.appspot.com',
  messagingSenderId: '321440477556'
});

let companiesFeedback = {};
const baseUrl = config.api;
window.app = app;

var companiesFeedbackRef = app.database().ref('companies');

var obj = {
  setCompanyId: cId => {
    companyId = cId;
  },
  getRepeatCount: () => {
    if (repeatCount) {
      return repeatCount;
    } else {
      var url = new URL(window.location.href);
      var c = url.searchParams.get('repeatCount');
      if (c) {
        repeatCount = c;
      }
    }
    return repeatCount;
  },
  getCompanyId: () => {
    if (companyId) {
      return companyId;
    }
  },
  getCompanyCurrency: () => {
    return obj.getCurrencySymbol(companyCache[obj.getCompanyId()].currency);
  },
  getCompanyForId: companyId => {
    obj.setCompanyId(companyId);

    if (promiseCache[companyId]) {
      return promiseCache[companyId];
    }

    let promise = new Promise((resolve, reject) => {
      fetch(`${baseUrl}/usage/company-data?companyId=${companyId}`, {
        credentials: 'include'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          companyCache[companyId] = data;
          if (data.error) {
            reject('error');
          } else {
            data['companyId'] = companyId;
            resolve(data);
          }
        })
        .catch(function(err) {
          console.error(err);
        });
    });

    promiseCache[companyId] = promise;

    return promiseCache[companyId];
  },
  getCurrencySymbol: currencyCode => {
    return getSymbolFromCurrency(currencyCode);
  },
  getInquiryCountByCity: () => {
    let companyId = obj.getCompanyId();

    if (inquiryByCityPromiseCache[companyId]) {
      return inquiryByCityPromiseCache[companyId];
    }

    let promise = new Promise((resolve, reject) => {
      fetch(`${baseUrl}/usage/inquiries?companyId=${companyId}`, {
        credentials: 'include'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          console.log('DATA RECEIVED', data);
          if (data.error) {
            reject('error');
          } else {
            resolve(data);
          }
        })
        .catch(function(err) {
          console.log(err);
          // resolve(data1);
        });
    });

    inquiryByCityPromiseCache[companyId] = promise;

    return inquiryByCityPromiseCache[companyId];
  },
  getVisitorCountByCity: () => {
    let companyId = obj.getCompanyId();

    if (visitorByCityPromiseCache[companyId]) {
      return visitorByCityPromiseCache[companyId];
    }

    let promise = new Promise((resolve, reject) => {
      fetch(`${baseUrl}/usage/visitors?companyId=${companyId}`, {
        credentials: 'include'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          if (data.error) {
            reject('error');
          } else {
            resolve(data);
          }
        })
        .catch(function(err) {
          console.log(err);
          // resolve(data1);
        });
    });

    visitorByCityPromiseCache[companyId] = promise;

    return visitorByCityPromiseCache[companyId];
  },
  startFeedbackListener: companyId => {
    companiesFeedbackRef
      .child(companyId)
      .child('feedback')
      .on('value', data => {
        let companyFeedbackData = data.val();
        companiesFeedback[companyId] = companyFeedbackData;
        console.log('FEEDBACK', companyFeedbackData);
        EventBus.dispatch(
          'company-feedback-' + companyId,
          this,
          companyFeedbackData
        );
      });
  },
  startCompanyMetaListener: companyId => {
    companiesFeedbackRef
      .child(companyId)
      .child('info')
      .on('value', data => {
        let companyFeedbackData = data.val();
        companiesFeedback[companyId] = companyFeedbackData;
        console.log('FEEDBACK', companyFeedbackData);
        EventBus.dispatch(
          'company-meta-' + companyId,
          this,
          companyFeedbackData
        );
      });
  },

  addFeedback: feedback => {
    let companyId = obj.getCompanyId();
    let key = app
      .database()
      .ref('/')
      .push().key;
    var feedbackData = {
      id: key,
      comment: feedback,
      timestamp_created: Date.now()
    };
    companiesFeedbackRef
      .child(companyId)
      .child('feedback')
      .child(key)
      .set(feedbackData)
      .then(response => {});
  },

  setMixPanelProperty: (companyId, propertyName, propertyValue) => {
    var data = {
      authToken: '299ad457-786d-4966-b27e-1f4d4b1a140f',
      companyId: companyId,
      props: {
        [propertyName]: propertyValue
      }
    };

    return fetch(
      'https://1024r140gd.execute-api.us-west-2.amazonaws.com/prod/mixpanel-prop-setter',
      {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'no-cors', // no-cors, cors, *same-origin
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
          // "Content-Type": "application/x-www-form-urlencoded",
        },
        body: JSON.stringify(data) // body data type must match "Content-Type" header
      }
    ).then(response => {});
  },
  saveCompanyInfo: info => {
    let companyId = obj.getCompanyId();

    Object.keys(info).forEach((key, i) => {
      obj.setMixPanelProperty(companyId, 'cf_' + key, info[key]);
    });

    obj.setMixPanelProperty(companyId, 'cf_analyzed', true);

    companiesFeedbackRef
      .child(companyId)
      .child('info')
      .update(info)
      .then(response => {});
  },
  getCompanySignatureMeta: companyId => {
    let promise = new Promise((resolve, reject) => {
      fetch(`${baseUrl}/usage/signature?companyId=${companyId}`, {
        credentials: 'include'
      })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          if (data.error) {
            reject('error');
          } else {
            resolve(data.reverse());
          }
        })
        .catch(function(err) {});
    });

    return promise;
  },
  getVisitorRepeatCount: (companyId, baseCount) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${baseUrl}/usage/visitor-repeat-count?companyId=${companyId}&baseCount=${baseCount}`,
        {
          credentials: 'include'
        }
      )
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          if (data.error) {
            reject('error');
          } else {
            resolve(data);
          }
        })
        .catch(function(err) {});
    });
  },
  getCompanyMeta: companyId => {
    return fetch(`${baseUrl}/usage/company-meta?companyId=${companyId}`, {
      credentials: 'include'
    })
      .then(function(res) {
        return res.json();
      })
      .catch(function(err) {
        console.error(err);
      });
  }
};

export default obj;



// WEBPACK FOOTER //
// ./src/pages/UsageDashboard/DataManager.js